import React, { useContext, useEffect } from "react";
import { TScreen } from "api/type";

// Import Components
import { ScreenContext } from "contexts";
import ScreenChatBot from "./ScreenChatBot";

type RootOnboardingChatBotProps = {};

const RootOnboardingChatBot: React.FC<RootOnboardingChatBotProps> = () => {
  // Context and State Declarations
  // const session = useContext(SessionContext);
  // const clinic = useContext(ClinicContext);

  const [screen, setScreen] = useContext(ScreenContext);

  // Effect: Set Screen to Video Screen
  useEffect(() => {
    setScreen(TScreen.CHATBOT_SCREEN);
  }, [setScreen]);

  // Render Screen based on the current context
  const renderScreen = () => {
    switch (screen) {
      case TScreen.CHATBOT_SCREEN:
        return <ScreenChatBot />;
      default:
        return null;
    }
  };

  return (
    <div id="onboarding-advertise-container" style={{ background: "#EBCDC1" }}>
      {renderScreen()}
    </div>
  );
};

export default RootOnboardingChatBot;
